import * as moment from 'moment';
import { random } from 'lodash';
import * as papa from 'papaparse';
import store from './store';

export const breakpoints = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1600
};

export const FamilyRelationship = {
	Child: '52866e41fdfae711b9c80028f80bded3',
	Spouse: '53866e41fdfae711b9c80028f80bded3',
	Partner: '54866e41fdfae711b9c80028f80bded3',
	Parent: '55866e41fdfae711b9c80028f80bded3',
	Other: '56866e41fdfae711b9c80028f80bded3'
};

export const PaymentStatus = {
	Created: '56b11e964101e811b9c9005056c00008',
	PaymentFailed: '57b11e964101e811b9c9005056c00008',
	PaymentSucceeded: '58b11e964101e811b9c9005056c00008'
};

export const BouncedEmailStatus = {
	Resolved: '6ca02d682d17e811b9d20028f80bded3',
	Unresolved: '6da02d682d17e811b9d20028f80bded3'
};

export const PickListType = {
	Countries: '122884bda5f1e711b9c70028f80bded3',
	ForeignCountries: '10f482f2a73ee811b9dc0028f80bded3',
	Provinces: 'f52f6166a4f1e711b9c70028f80bded3',
};

export const PolicyStatus = {
	Active: '39e9315ede02e811b9c9005056c00008',
	Inactive: '3ae9315ede02e811b9c9005056c00008',
	Canceled: '3be9315ede02e811b9c9005056c00008',
};

export const BeneficiaryStatus = {
	Confirmed: 'a7830d925f08e811b9cd0028f80bded3',
	Unconfirmed: 'a8830d925f08e811b9cd0028f80bded3',
	PendingPaperwork: 'a9830d925f08e811b9cd0028f80bded3',
	PendingReceipt: 'aa830d925f08e811b9cd0028f80bded3'
};

export const BeneficiaryTypes = {
	Primary: 'ea0bdce7b30e41f48ffbdce43d437497',
	Contingent: 'eb0bdce7b30e41f48ffbdce43d437497',
	Trustee: 'ec0bdce7b30e41f48ffbdce43d437497'
};

export const ReferralStatus = {
	ReferralPending: '3a8a89ecb99a42009a59f1c63824a63a',
	PolicyCancelled: '3b8a89ecb99a42009a59f1c63824a63a',
	ReferralApproved: '3c8a89ecb99a42009a59f1c63824a63a'
};

export const AdjudicationStatus = {
	Unreviewed: '5a37027166774fd69d20a8790986980e',
	InProcess: '5b37027166774fd69d20a8790986980e',
	Rejected: '5c37027166774fd69d20a8790986980e'
};

export const B2CConfiguration = {
	clientID: process.env.REACT_APP_B2C_ClientID!,
	authoritySignIn: process.env.REACT_APP_B2C_Authority_Url_Part! + process.env.REACT_APP_B2C_SignIn_PolicyName,
	authoritySignInMultiFactor: process.env.REACT_APP_B2C_Authority_Url_Part! + process.env.REACT_APP_B2C_SignIn_MultiFactor_PolicyName,
	authoritySignUp: process.env.REACT_APP_B2C_Authority_Url_Part! + process.env.REACT_APP_B2C_SignUp_PolicyName,
	b2cScopes: process.env.REACT_APP_B2C_Scopes!.split(','),
	policyNameSignUp: process.env.REACT_APP_B2C_SignUpPolicyName,
	policyNameMultiFactor: process.env.REACT_APP_B2C_SignIn_MultiFactor_PolicyName!,
	policyNameResetPwd: process.env.REACT_APP_B2C_ResetPwd_PolicyName!,
};
export const enum SecurityRoles {
	Administrator = 'Admin',
	Agent = 'Agent',
	Customer = 'Customer',
	Adjudicator = 'Adjudicator'
}

export interface InputError {
	hasError: boolean;
	message: string;
}

// tslint:disable
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
// tslint:enable

export const NumInchesInFeet = 12;
export const NumCmInInches = 2.54;
export const ReferralHealthScoreMin = 54;

export class Validation {
	static validateAge = (birthDate?: string, isAuthenticated?: boolean) => {
		const d = moment(birthDate);
		if (!d.isValid()) {
			return {
				hasError: true,
				message: 'Date is invalid.'
			} as InputError;
		}

		const age = Utils.getAgeFromBirthdate(birthDate);
		if (isAuthenticated) {
			return {
				hasError: age !== '' && age != null && (age < 18 || age > 54), // TODO: allow existing up to age 59, refer work item #7620
				message: 'Age must be 18-54.'
			} as InputError;
		} else {
			return {
				hasError: age !== '' && age != null && (age < 18 || age > 54),
				message: 'Age must be 18-54.'
			} as InputError;
		}
	}
	static validateEmail = (email?: string) => {
		return {
			hasError: email && !email.match(emailRegex),
			message: 'Email is not valid.'
		} as InputError;
	}
	static validatePostalCode = (postalCode?: string, message?: string) => {
		return {
			hasError: postalCode && !postalCode.match(postalCodeRegex),
			message: message || 'Postal code is not valid.'
		} as InputError;
	}
	static validateDate = (date?: string, format?: string, strict?: boolean) => {
		const d = moment(date, format, strict);
		return {
			hasError: !d.isValid(),
			message: !d.isValid() ? 'Date is invalid.' : ''
		} as InputError;
	}
	static validateRequired = (fieldName: string, value?: string): InputError => {
		if (value) {
			return {
				hasError: false,
				message: ''
			};
		}
		else {
			return {
				hasError: true,
				message: `${fieldName} is required`
			};
		}
	}
	static validateTerm = (termLength?: string | number): InputError => {
		const isError = termLength === undefined || !(termLength >= 1 && termLength <= 47);
		return {
			hasError: isError,
			// due to some strange CSS causing the rows to shift.
			// this is getting left as ''
			message: '',
		};
	}
}

class Utils {
	// tslint:disable
	static generateUUID = () => {
		let d = new Date().getTime();
		const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
			const r = ((d + Math.random() * 16) % 16) | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
		});
		return uuid;
	};
	// tslint:enable

	static formatDate(d: any, format?: string) {
		if (!d) {
			return '';
		}

		return moment(d).format(format || 'YYYY-MM-DD');
	}
	static formatDateAsUTC(d: any, format?: string) {
		// this formats a date as utc.  
		// we can use this to ensure that a date only value from the server isn't converted to local time
		if (!d) {
			return '';
		}

		return moment(d).utc().format(format || 'YYYY-MM-DD');
	}
	static isValidDate(d?: string, format?: string) {
		return moment(d, 'YYYY-MM-DD', true).isValid();
	}
	static formatUnixDate(d: any, format?: string) {
		if (!d) {
			return '';
		}

		return moment.unix(d).format(format || 'YYYY-MM-DD');
	}

	static getAgeRoundedFromBirthdate(d?: string) {
		if (!d || d.length < 6) {
			return '';
		}
		const ageInDays = moment().utc().diff(moment(d, 'YYYYMMDD'), 'days', true);
		const daysInYear = 365.2425; // statistical value for 400 years
		const ageInYears = (ageInDays / daysInYear);
		// const momentYear = moment().diff(moment(d, 'YYYYMMDD'), 'years', true);
		return Math.round(ageInYears);
	}
	static getAgeFromBirthdate(d?: string) {
		if (!d || d.length < 6) {
			return '';
		}

		return Math.floor(moment().diff(moment(d, 'YYYYMMDD'), 'years', true));
	}

	static dateStringToDate(d: string) {
		if (moment(d, 'YYYY-MM-DD').isValid()) {
			return moment(d, 'YYYY-MM-DD').toDate();
		} else {
			return null;
		}
	}

	// Note: For datetime passed from server we have to use toDate() when compare dates
	static getDayFromCreatedDate(d?: string) {
		if (!d || d.length < 6) {
			return '';
		}
		const createdDate = moment(d).toDate();
		return (moment().diff(createdDate, 'days'));
	}

	static getPickListItemDescription(pickListItemId?: string) {
		if (pickListItemId) {
			const storeState = store.getState() as any;
			const storePickListItems = storeState.pickList.items as PickListItem[];
			const match = storePickListItems.find(p => p.id === pickListItemId);
			if (match) {
				return match.description;
			}
		}

		return '';
	}

	static getCategoryInfoByNoteAnswerId(answerId?: string) {
		if (answerId) {
			const storeState = store.getState() as any;
			const storeAnswers = storeState.policy.answers.answerList as ApplicationAnswerDto[];
			const storePolicies = storeState.policy.policies as CustomerPolicy[];
			const match = storeAnswers.find(a => a.id === answerId);
			if (match) {
				const matchPolicy = storePolicies.find(p => p.id === match.policyId);
				if (matchPolicy) {
					return matchPolicy.number + ' Q' + match.categoryId + '.' + match.subCategoryId;
				}
			}
		}

		return '';
	}

	static getQuestionTextByAnswer(answer: string) {
		const storeState = store.getState() as any;
		const storeQuestions = storeState.question.questions as { [name: string]: string; }[];
		var key, keys = Object.keys(storeQuestions);
		var n = keys.length;
		var questionsWithLowercaseNames = {};
		var regex = /<.*?>/gi;
		while (n--) {
			key = keys[n];
			questionsWithLowercaseNames[key.toLowerCase()] = storeQuestions[key].replace(regex, '');
		}
		const match = questionsWithLowercaseNames[answer.replace(/ /g, '').toLowerCase()];
		if (match) {
			return match;
		}
		return '';
	}

	static verifyAnswerHasNotes(answerId?: string) {
		if (answerId) {
			const storeState = store.getState() as any;
			const storeNotes = storeState.user.notes as CustomerNote[];
			const hasNotes = storeNotes.find(n => n.answerId === answerId);
			if (hasNotes) {
				return true;
			}
		}
		return false;
	}

	static forEachPromise(items: any, fn: any) {
		return items.reduce(
			function (promise: any, item: any) {
				return promise.then(function () {
					return fn(item);
				});
			},
			Promise.resolve()
		);
	}

	static isAuthorized(hasRoles: string[], rolesRequired: string[]) {
		let authorized = false;
		if (hasRoles.indexOf('admin') >= 0 || rolesRequired == null || rolesRequired.length === 0) {
			authorized = true;
		}
		else {
			authorized = hasRoles.some(role => {
				return rolesRequired.indexOf(role) >= 0;
			});
		}
		return authorized;
	}

	static generateCode = () => {
		// Generates a random alphanumeric string of length 6
		return Math.random()
			.toString(36)
			.substr(2, 6);
	}

	// https://gist.github.com/bsara/c60dd6bbb04e0969221f607f0df68716
	static getScrollbarWidth = () => {
		const outer = document.createElement('div');
		const inner = document.createElement('div');

		outer.style.visibility = 'hidden';
		outer.style.width = '100px';
		inner.style.width = '100%';

		outer.appendChild(inner);
		document.body.appendChild(outer);

		const widthWithoutScrollbar = outer.offsetWidth;

		outer.style.overflow = 'scroll';

		const widthWithScrollbar = inner.offsetWidth;

		document.body.removeChild(outer);

		return widthWithoutScrollbar - widthWithScrollbar;
	}

	static debounce = (fn: () => void, delay = 50) => {
		let timer: any;
		return () => {
			clearTimeout(timer);
			timer = setTimeout(() => fn(), delay);
		};
	}

	static disableBodyScrolling = (args: any = {}) => {
		const className = args.className || 'disable-scroll';
		const allBreakpoints = args.allBreakpoints || false;

		document.body.classList.add(className);
		const fixedEls = document.querySelectorAll('[data-adjust-fixed-scrollbar]');
		if ((allBreakpoints || window.innerWidth < breakpoints.xl) && (window.innerHeight < document.body.offsetHeight)) {
			for (let i = 0; i < fixedEls.length; i++) {
				(fixedEls[i] as HTMLElement).style.paddingRight = `${Utils.getScrollbarWidth()}px`;
			}
		}
	}

	static enableBodyScrolling = (args: any = {}) => {
		const className = args.className || 'disable-scroll';

		document.body.classList.remove(className);
		const fixedEls = document.querySelectorAll('[data-adjust-fixed-scrollbar]');
		for (let i = 0; i < fixedEls.length; i++) {
			(fixedEls[i] as HTMLElement).style.paddingRight = '';
		}
	}

	static formatCurrency = (value?: number, decimals?: number) => {
		if (value == null) {
			return '';
		}

		var formatter = new Intl.NumberFormat('en-CA', {
			style: 'currency',
			currency: 'CAD',
			minimumFractionDigits: decimals === undefined ? 2 : decimals,
			maximumFractionDigits: decimals === undefined ? 2 : decimals,
		});

		return formatter.format(value);
	}

	static formatNumberWithCommas = (value?: any) => {
		if (value == null) {
			return '';
		}

		value = value.toString();
		// Replace all non-digits and non-periods with empty string.
		value = value.replace(/[^\.\d]/g, '');
		// Insert a comma after every 3 digits.
		value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		// Only allow 1 decimal and limit the input to 2 decimal spaces.
		value = value.replace(/^([\d|\,]+\.?\d?\d?)?.*/, '$1');

		return value;
	}

	static getAbbreviatedNumber = (value: number) => {
		if (value >= 1000000) {
			return value / 1000000 + ' million';
		} else if (value >= 1000) {
			return value / 1000 + 'k';
		}

		return value.toString();
	}

	static setDocTitle = (value: string | undefined) => {
		const titleSuffix = 'Mosaic Life';
		if (value) {
			document.title = `${value} | ${titleSuffix}`;
		} else {
			document.title = titleSuffix;
		}
	}

	static shouldMarkError = (error: InputError, touched: boolean) => {
		const hasError = error.hasError;
		const shouldShow = touched;
		return hasError ? shouldShow : false;
	}

	static extractIdToken = (encodedIdToken: string) => {
		// id token will be decoded to get the username
		var decodedToken = Utils.decodeJwt(encodedIdToken);
		if (!decodedToken) {
			return null;
		}
		try {
			var base64IdToken = decodedToken.JWSPayload;
			var base64Decoded = Utils.base64DecodeStringUrlSafe(base64IdToken);
			if (!base64Decoded) {
				// this._requestContext.logger.info('The returned id_token could not be base64 url safe decoded.');
				return null;
			}
			// ECMA script has JSON built-in support
			return JSON.parse(base64Decoded);
		} catch (err) {
			// this._requestContext.logger.error('The returned id_token could not be decoded' + err);
		}
		return null;
	}
	static decodeJwt = (jwtToken: string) => {
		if (Utils.isEmpty(jwtToken)) {
			return null;
		}
		var idTokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
		var matches = idTokenPartsRegex.exec(jwtToken);
		if (!matches || matches.length < 4) {
			// this._requestContext.logger.warn('The returned id_token is not parseable.');
			return null;
		}
		var crackedToken = {
			header: matches[1],
			JWSPayload: matches[2],
			JWSSig: matches[3]
		};
		return crackedToken;
	}
	static base64DecodeStringUrlSafe = (base64IdToken: string) => {
		// html5 should support atob function for decoding
		base64IdToken = base64IdToken.replace(/-/g, '+').replace(/_/g, '/');
		if (window.atob) {
			return decodeURIComponent(window.atob(base64IdToken)); // jshint ignore:line
		} else {
			return decodeURIComponent(Utils.decode(base64IdToken));
		}
	}
	static decode = (base64IdToken: string) => {
		var codes = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
		base64IdToken = String(base64IdToken).replace(/=+$/, '');
		var length = base64IdToken.length;
		if (length % 4 === 1) {
			throw new Error('The token to be decoded is not correctly encoded.');
		}
		var h1,
			h2,
			h3,
			h4,
			bits,
			c1,
			c2,
			c3,
			decoded = '';
		for (var i = 0; i < length; i += 4) {
			// Every 4 base64 encoded character will be converted to 3 byte string, which is 24 bits
			// then 6 bits per base64 encoded character
			h1 = codes.indexOf(base64IdToken.charAt(i));
			h2 = codes.indexOf(base64IdToken.charAt(i + 1));
			h3 = codes.indexOf(base64IdToken.charAt(i + 2));
			h4 = codes.indexOf(base64IdToken.charAt(i + 3));
			// tslint:disable
			// For padding, if last two are '='
			if (i + 2 === length - 1) {
				bits = (h1 << 18) | (h2 << 12) | (h3 << 6);
				c1 = (bits >> 16) & 255;
				c2 = (bits >> 8) & 255;
				decoded += String.fromCharCode(c1, c2);
				break;
			} else if (i + 1 === length - 1) {
				bits = (h1 << 18) | (h2 << 12);
				c1 = (bits >> 16) & 255;
				decoded += String.fromCharCode(c1);
				break;
			}

			bits = (h1 << 18) | (h2 << 12) | (h3 << 6) | h4;
			// then convert to 3 byte chars
			c1 = (bits >> 16) & 255;
			c2 = (bits >> 8) & 255;
			c3 = bits & 255;
			// tslint:enable
			decoded += String.fromCharCode(c1, c2, c3);
		}
		return decoded;
	}
	static isEmpty = (str?: string) => {
		return typeof str === 'undefined' || !str || 0 === str.length;
	}

	static getHeightInInches = (inputHeight: any, heightUnit: string, inputHeightft: any) => {
		// inputHeight is either cm/in depending on heightUnit
		// inputHeightft is a separate input field if heightUnit is in
		let height = parseInt(inputHeight, 10);
		// Convert height to inches regardless of whether it is in ft/in or cm
		// to make calculations and conditional checking easier
		if (heightUnit === 'in') {
			const heightft = Math.round(inputHeightft);
			if (heightft) {
				height += heightft * NumInchesInFeet;
			}
		}
		else {
			height /= NumCmInInches;
		}

		return Math.round(height);
	}

	static parseValueFromEvent(e: any) {
		let value = e.target.value;
		if (e.target.type === 'radio') {
			if (value === 'true') {
				value = true;
			}
			else if (value === 'false') {
				value = false;
			}
		}
		else if (e.target.type === 'checkbox') {
			value = e.target.checked;
		}

		if (e.target.min) {
			value = Math.max(value, e.target.min).toString();
		}
		if (e.target.max) {
			value = Math.min(value, e.target.max).toString();
		}

		return value;
	}

	static downloadCsv(data: any, filename: string, isCsvFormat?: boolean) {
		let csv;
		if (isCsvFormat) {
			csv = data;
		} else {
			csv = papa.unparse(data);
		}

		var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
		// IE11 & Edge
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(csvData, filename);
		}
		else {
			// In FF link must be added to DOM to be clicked
			var link = document.createElement('a');
			link.href = window.URL.createObjectURL(csvData);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}

	// Works similar to C#'s String.Format(). str takes the form of "Hello {0}".
	static formatString(str: string, ...args: string[]) {
		return str.replace(/{(\d+)}/g, function (match: string, num: number) {
			return typeof args[num] !== 'undefined'
				? args[num]
				: match
				;
		});
	}

	static formatFirstUpperCase(str: string) {
		return str.replace(/^\w/, c => c.toUpperCase());
	}

	static toPercent(num?: number) {
		let r;
		if (num) {
			r = (num * 100).toFixed(2).toString();
		} else {
			r = '0';
		}

		return r + '%';
	}

	static getABTestOptimizeIndex() {
		const workflowIndex = random(0, 1);

		return workflowIndex;
	}
	static getABTestWorkflowUrl(optimzeIndex: number, age?: number, gender?: string) {
		let code = 'A';
		switch (optimzeIndex) {
			case 0:
				code = 'A';
				break;
			case 1: 
				code = 'C';
				break;
			default: 
				code = 'A';
				break;
		}

		let page = 'select-your-policy';
		if (!age || !gender || age > 54 || age < 18) {
			page = 'about-you';
		}
		else if (code === 'B') {
			page = 'your-needs';
		}

		return `/quote/${code}/${page}`;
	}
}
export default Utils;

export class UtilsBeneficiaries {
	static isDisbursementValid = (beneficiaries: Array<CustomerPolicyBeneficiaryDto>) => {
		const primaryBeneficiaries = beneficiaries.filter(b => b.typeId === BeneficiaryTypes.Primary);
		let primaryDisbursementTotal = primaryBeneficiaries
			.reduce((a, b) => a + parseFloat((b.disbursementPercent as any) || 0), 0);
		primaryDisbursementTotal = Math.round(primaryDisbursementTotal * 100) / 100;
		const isPrimariesValid = primaryDisbursementTotal === 1 
			|| (primaryDisbursementTotal === 0 && primaryBeneficiaries.length === 0);

		const contingentBeneficiaries = beneficiaries.filter(b => b.typeId === BeneficiaryTypes.Contingent);
		let contingentDisbursmentTotal = contingentBeneficiaries
			.reduce((a, b) => a + parseFloat((b.disbursementPercent as any) || 0), 0);
		contingentDisbursmentTotal = Math.round(contingentDisbursmentTotal * 100) / 100;
		const isContingentValid = contingentDisbursmentTotal === 1 
			|| (contingentDisbursmentTotal === 0 && contingentBeneficiaries.length === 0);
		
		return isPrimariesValid && isContingentValid;
	}

	static sortPrimaryThenByName = (a: CustomerPolicyBeneficiaryDto, b: CustomerPolicyBeneficiaryDto) => {
		const comparePrimary = (a1: CustomerPolicyBeneficiaryDto, b1: CustomerPolicyBeneficiaryDto) => {
			if (a1.typeId === BeneficiaryTypes.Primary && b1.typeId === BeneficiaryTypes.Contingent) {
				return -1;
			}
	
			if (b1.typeId === BeneficiaryTypes.Primary && a1.typeId === BeneficiaryTypes.Contingent) {
				return 1;
			}
	
			return 0;
		};

		const compareFirstName = (a1: CustomerPolicyBeneficiaryDto, b1: CustomerPolicyBeneficiaryDto) => {
			return ('' + a1.firstName).localeCompare('' + b1.firstName);
		};

		return comparePrimary(a, b) || compareFirstName(a, b);		
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/utils.ts